import { AxiosRequestConfig, InternalAxiosRequestConfig } from "axios";
import axios from "axios";
import { User } from "@/models/User";
import { useUserStore } from "@/stores/root/users";
import { useQuoteStore } from "@/stores/root/quote";

const instanceAxios = axios.create();
instanceAxios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const rToken = localStorage.getItem("rToken");
    const token = localStorage.getItem("token");
    config.headers = config.headers ?? {};
    config.headers["X-ReCaptcha"] = rToken;
    config.headers.Authorization = "Bearer " + token;
    config.headers["X-Requested-With"] = "XMLHttpRequest";
    // config.url = config?.url?.replace("http://", "https://");
    return config;
  },
  (error: any) => Promise.reject(error)
);
instanceAxios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      const quote = useQuoteStore();
      const userStore = useUserStore();
      userStore.logout();
      if (
        quote.currentStep == "quote-checkout" ||
        quote.currentStep == "quote-review"
      ) {
        quote.setQuoteStep("quote-account");
      }
    }
    return Promise.reject(error);
  }
);

export default instanceAxios;
